import { Menu, MenuButton, Spacer } from '@chakra-ui/react';
import * as React from 'react';
import { Icon } from './Icon';
import { HStack } from './primitives/stack/HStack';
import { VStack } from './primitives/stack/VStack';
import { Text } from './primitives/Text';

interface Props {
  avatar: React.ReactNode;
  label: string;
  subLabel?: string;
  children: React.ReactNode;
}

export function UserCard({ avatar, label, subLabel, children }: Props) {
  return (
    <Menu>
      <MenuButton _hover={{ bg: 'gray.10', boxShadow: '0 0 0 8px var(--chakra-colors-gray-10)' }} borderRadius={4}>
        <HStack w="100%" spacing={2} >
          {avatar}

          <VStack w="100%" spacing="2px" alignItems="flex-start">
            <Text lineHeight="16px" noOfLines={1} maxW={125} textAlign="left" fontWeight={500}>{label}</Text>
            { subLabel && <Text lineHeight="16px" color="gray.400" noOfLines={1} textAlign="left">{subLabel}</Text> }
          </VStack>

          <Spacer />

          <Icon icon='verticalDots' />
        </HStack>
      </MenuButton>

      {children}
    </Menu>
  );
}